/** Match backend parse_building_number_query — house numbers, not road refs. */

const ROAD_REF_ONLY_RE = /^(?:N|R|IR|LR)\d+$/i;
const ROAD_DISTRICT_SEQ_RE = /^[A-Z]{2}-\d+/i;
const BUILDING_NUMBER_QUERY_RE = /^(\d+[A-Za-z]?(?:-\d+[A-Za-z]?)?)(?:\s+(.+))?$/;

const COORDAL_HOUSE_NUMBER_RE = /^\d+-[A-Za-z]\d+(?:\s+(.+))?$/i;

function normalizeBuildingNumberQuery(query: string): string {
  return query.trim().replace(/^building\s+/i, '');
}

export function looksLikeBuildingNumberQuery(query: string): boolean {
  const raw = normalizeBuildingNumberQuery(query);
  if (!raw) return false;
  const compact = raw.replace(/\s+/g, '');
  if (ROAD_REF_ONLY_RE.test(compact) || ROAD_DISTRICT_SEQ_RE.test(compact)) {
    return false;
  }
  return BUILDING_NUMBER_QUERY_RE.test(raw) || COORDAL_HOUSE_NUMBER_RE.test(raw);
}

/** Shorter queries allowed for house-number autocomplete (e.g. "45", "1"). */
export function autocompleteMinLength(query: string): number {
  return looksLikeBuildingNumberQuery(query) ? 2 : 3;
}
